import React, { useState } from "react";
import { subscribeNewsletter } from "@/lib/api";
import { Loader2, CheckCircle2, Download } from "lucide-react";

export default function Newsletter({ variant = "light", source = "inline", leadMagnet = null }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const dark = variant === "dark";

  async function handleSubmit(e) {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    setError("");
    try {
      await subscribeNewsletter({ email, source });
      setStatus("success");
      setEmail("");
    } catch (err) {
      setStatus("error");
      setError(err?.response?.data?.detail || "Something went wrong. Try again.");
    }
  }

  if (status === "success") {
    if (leadMagnet) {
      return (
        <div data-testid={`newsletter-success-${source}`} className="flex flex-col gap-3">
          <div className={`flex items-center gap-2 text-sm ${dark ? "text-gold" : "text-teal"}`}>
            <CheckCircle2 className="w-5 h-5" />
            You&apos;re on the list — your download is ready!
          </div>
          <a
            href={leadMagnet.url}
            download
            data-testid={`newsletter-download-${source}`}
            className="inline-flex items-center gap-2 bg-gold text-navy hover:bg-gold/90 transition-colors rounded-full px-6 py-3 text-xs font-medium uppercase tracking-wider shadow self-start"
          >
            <Download className="w-4 h-4" /> {leadMagnet.label || "Download Your Free Guide"}
          </a>
        </div>
      );
    }
    return (
      <div
        data-testid={`newsletter-success-${source}`}
        className={`flex items-center gap-2 text-sm ${
          dark ? "text-gold" : "text-teal"
        }`}
      >
        <CheckCircle2 className="w-5 h-5" />
        You&apos;re on the list. Welcome to ConnectHER.
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      data-testid={`newsletter-form-${source}`}
      className="flex flex-col sm:flex-row gap-3"
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        data-testid={`newsletter-input-${source}`}
        className={`flex-1 rounded-full px-5 py-3 text-sm outline-none transition focus:ring-2 focus:ring-gold ${
          dark
            ? "bg-white/10 text-soft placeholder:text-soft/40 border border-soft/15"
            : "bg-white border border-navy/10 text-navy placeholder:text-navy/40"
        }`}
      />
      <button
        type="submit"
        disabled={status === "loading"}
        data-testid={`newsletter-submit-${source}`}
        className="inline-flex items-center justify-center gap-2 bg-gold text-white hover:bg-gold-dark transition-colors rounded-full px-6 py-3 text-xs font-medium uppercase tracking-wider shadow"
      >
        {status === "loading" ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          "Subscribe"
        )}
      </button>
      {error && (
        <p
          data-testid={`newsletter-error-${source}`}
          className="text-xs text-red-400 sm:w-full"
        >
          {error}
        </p>
      )}
    </form>
  );
}
